module.exports = __webpack_public_path__ + "static/media/KREDIT-DINAMIS-470x470.526055cf.jpg";